import React, { createContext, useEffect, useState } from 'react';
import { useTranslationsManager } from './TranslationsProvider';
import { useLocale } from '..';
import { useBrand } from '../brand';

export const InitializedTranslationsContext = createContext(false);

const fetchTranslations = ({ translationLoaders, brand, locale }) => {
  const translationPromises = Object.entries(translationLoaders).map(
    ([namespace, translationLoader]) => {
      return translationLoader({ brand, locale })
        .then((nsTranslations) => {
          return [namespace, nsTranslations.default];
        })
        .catch(() => {
          return [namespace, {}];
        });
    }
  );

  return Promise.all(translationPromises).then((translationList) => {
    return translationList.reduce(
      (translations, [namespace, nsTranslations]) => {
        translations[namespace] = nsTranslations;
        return translations;
      },
      {}
    );
  });
};

const createTranslationsPageProvider = (translationLoaders) => {
  const useAddResource = () => {
    const [initialized, setInitialized] = useState(false);
    const brand = useBrand();
    const locale = useLocale();
    const translationsManager = useTranslationsManager();
    useEffect(() => {
      let isMounted = true;
      fetchTranslations({ translationLoaders, brand, locale }).then(
        (translations) => {
          translationsManager.add(locale, { ...translations }, () => {
            if (isMounted) {
              setInitialized(true);
            }
          });
        }
      );
      return () => {
        isMounted = false;
      };
    }, [translationsManager, brand, locale]);
    return initialized;
  };

  return function TranslationsPageProvider({ children }) {
    const initialized = useAddResource();
    return (
      <InitializedTranslationsContext.Provider value={initialized}>
        {children}
      </InitializedTranslationsContext.Provider>
    );
  };
};

export default createTranslationsPageProvider;
